const hartfordNewInsightsPage = `
{{#> hartford/NavLayout currentPage=currentPage Pages=Pages basePath=basePath logoUrl=project.values.logoUrl }}
  <div class="insights-container">
    <h2 class="headline">{{ project.values.newInsightsHeadline }}</h2>

    <div class="insights-grid">
      {{#each pageContext.new_insights}}
        <div class="insight-card">
          <h3 class="insight-title">{{this.title}}</h3>
          <p class="insight-text">{{this.text}}</p>
          <a href="{{this.url}}" class="insight-link">{{this.link_text}}</a>
        </div>
      {{/each}}
    </div>
  </div>
{{/ hartford/NavLayout}}
`;

const hartfordNewInsightItem = `
<div class="insight-card">
  <h3 class="insight-title">{{title}}</h3>
  <p class="insight-text">{{text}}</p>
  <a href="{{url}}" class="insight-link">{{link_text}}</a>
</div>
`;

const hartfordNewInsightsPageStyles = `
.headline {
  color:rgb(0, 82, 163);
  font-weight: bold;
  font-size: 32px;
  margin-top: 48px;
  margin-bottom: 96px;
}

.insights-container {
  max-width: 1200px;
  margin: 40px auto;
  padding: 0 20px;
}

.insights-grid {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 30px;
}

.insights-grid > :nth-child(1) {
  grid-column: span 3;
}

.insights-grid > :nth-child(2) {
  grid-column: span 3;
}

.insights-grid > :nth-child(n + 3) {
  grid-column: span 2;
}

.insight-card {
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  padding: 25px;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  display: flex;
  flex-direction: column;
  height: 270px; /* Fixed height as requested */
  max-height: 270px;
  overflow: hidden;
}

.insight-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
}

.insight-title {
  font-size: 20px;
  font-weight: 600;
  color: #333;
  margin: 0 0 15px 0;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.insight-text {
  font-size: 16px;
  color: #555;
  margin: 0 0 20px 0;
  flex-grow: 1;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.insight-link {
  font-size: 16px;
  font-weight: 600;
  color: #0066cc;
  text-decoration: none;
  display: inline-block;
  margin-top: auto;
  transition: color 0.2s ease;
}

.insight-link:hover {
  color: #004999;
  text-decoration: underline;
}

@media (max-width: 992px) {
  .insights-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 576px) {
  .insights-grid {
    grid-template-columns: 1fr;
  }
}
`;

export const newInsightsBlocks: any[] = [
  {
    name: 'hartford/NewInsightsPage',
    partial: hartfordNewInsightsPage,
    css: hartfordNewInsightsPageStyles,
  },
  {
    name: 'hartford/NewInsightItem',
    partial: hartfordNewInsightItem,
    css: hartfordNewInsightsPageStyles,
  },
];
